import { useState } from "react";
import { Store } from "lucide-react";

type NovaBrandProps = {
  compact?: boolean;
  subtitle?: string;
};

export function NovaBrand({
  compact = false,
  subtitle = "Operations cockpit",
}: NovaBrandProps) {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className={`flex min-w-0 items-center ${compact ? "gap-3" : "gap-4"}`}>
      <div
        className={`grid shrink-0 place-items-center overflow-hidden rounded-xl border border-white/10 bg-[#F8F6F1] ${
          compact ? "h-11 w-11" : "h-16 w-16"
        }`}
      >
        {!logoFailed ? (
          <img
            src="/images/nova/novatransparent.png"
            alt="Nova Res Culina"
            className="h-full w-full object-contain"
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <Store className="h-7 w-7 text-[#2F5B45]" />
        )}
      </div>

      <div>
        <p className={`${compact ? "text-[15px]" : "text-xl"} font-bold tracking-tight`}>
          Nova Res Culina
        </p>
        <p className="mt-1 text-[10px] uppercase tracking-[.18em] opacity-55">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
